import React from 'react';
import styled from '@emotion/styled';

interface ActionButtonProps {
  text: string;
  onClick: () => void;
  disabled?: boolean;
}

const Button = styled.button<{ disabled?: boolean }>`
  width: 100%;
  max-width: 320px;
  padding: 20px 32px;
  background: transparent;
  color: white;
  border: 3px solid white;
  border-radius: 50px;
  font-size: 18px;
  font-weight: 600;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  opacity: ${props => props.disabled ? 0.6 : 1};
  transition: all 0.3s ease;
  
  &:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.15);
    transform: translateY(-2px);
  }
  
  &:active:not(:disabled) {
    transform: translateY(0);
  }
`;

export const ActionButton: React.FC<ActionButtonProps> = ({ 
  text, 
  onClick, 
  disabled = false 
}) => {
  return (
    <Button onClick={onClick} disabled={disabled}>
      {text}
    </Button>
  );
};

export default ActionButton;
